import React, { useState } from 'react';
import classnames from 'classnames';
import copyIcon from 'v2/icons/copyIcon.svg';
import styles from './bccEmail.module.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const BccEmail = () => {
  const bccEmail = 'drm@bcc.nomad-data.com';
  const [showTooltip, setShowTooltip] = useState(false);
  const handleCopyClick = () => {
    navigator.clipboard.writeText(bccEmail);
    setShowTooltip(true);
  };
  const handleTooltipToggle = () => {
    setTimeout(() => {
      setShowTooltip(false);
    }, 500);
  };
  return (
    <div>
      <p className={classnames(styles.label, 'mt-5 mb-4')}>Nomad Data Email</p>
      <div className={styles.bccEmailContainer}>
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip`} className={styles.tooltip}>
              {`BCC this address on any email you want to log in your DRM. 
            The system creates an Email activity and will auto-create any 
            new Data Providers and Contacts who are recipients of each email.`}
            </Tooltip>
          }
        >
          <p className={styles.bccEmail}>{bccEmail}</p>
        </OverlayTrigger>
        <OverlayTrigger
          placement="right"
          trigger="click"
          overlay={
            <Tooltip id={`tooltip`} className={styles.tooltip}>
              {`Copied!`}
            </Tooltip>
          }
          show={showTooltip}
          onToggle={handleTooltipToggle}
        >
          <button className={styles.copy} onClick={handleCopyClick}>
            <img src={copyIcon} alt="Copy" className={styles.copyIcon} />
            Copy
          </button>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default BccEmail;
